export default {
  SET_IS_ONBOARDING_MODAL_VISIBLE: (state, payload) => {
    state.isOnboardingModalVisible = payload;
  },
  SET_ONBOARDING_MODAL_TRIGGER_ORIGIN: (state, payload) => {
    state.onboardingModalTriggerOrigin = payload;
  },
};
